<template>
  <div>
    <custom-dialog width="1300px" :showClose="true" v-if="carryDialogObj.show" :visible="carryDialogObj.show">
      <div slot="header" class="header-warp">
        <i class="el-icon-close header-warp-close" @click="close"></i>
        <div class="header-warp-item" :class="{ 'header-warp-item-active': form.status == item.value }"
          v-for="(item) in statusList" @click="changeStatus(item)">{{ item.label }}</div>
      </div>
      <div slot="content">
        <div class="content-top">
          <el-form ref="form" :model="form" :inline="true">
            <el-form-item label="收费医馆">
              <el-select v-model="form.deptId" placeholder="请选择" clearable>
                <el-option v-for="item in deptList" :key="item.value" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="带货时间" v-if="form.status == '1'">
              <el-date-picker v-model="form.date" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收费时间" v-else>
              <el-date-picker v-model="form.date" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="货号">
              <el-input v-model="form.productNo" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
              <el-button @click="onReset">重置</el-button>
            </el-form-item>
          </el-form>
          <div class="mb22">
            <el-button type="primary" @click="handleExport">导出</el-button>
          </div>
        </div>
        <customTable border :tableData="tableData" :column="column" height="520px" @pageChange="pageChange"
          :currentPage="form.pageNum" :total="total">
          <template slot="action" slot-scope="scope" v-if="form.status == '2'">
            <el-button type="text" @click="updateCarrStatus(scope.row)">标记已带货</el-button>
          </template>
          <template slot="change" slot-scope="scope" v-if="form.status == '1'">
            <el-button type="text" :disabled="scope.row.carryDeptId != currentDeptId || scope.row.affirmName" @click="updateCarrStatus(scope.row)">确认收货</el-button>
          </template>
        </customTable>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import customTable from '@/components/customTable/customTable'
import { getCarryList, updateCarrStatus } from '@/api/formula'
import { debounce,isNull } from '@/utils/validateBase';
import { reportExport } from '@/api/statement'
export default {
  components: { CustomDialog, customTable },
  props: {
    carryDialogObj: {
      type: Object,
      default: () => { return {} }
    },
  },
  data() {
    return {
      currentDeptId: this.$session.get('deptId'),
      form: {
        deptId: '',
        status: '',
        productNo: '',
        pageNum: 1,
        pageSize: 10,
        date: []
      },
      total: 0,
      statusList: [
        { value: '2', label: '待带货' },
        { value: '1', label: '已带货' },
      ],
      tableData: [],
      column: [],
      deptList: this.$session.get('options'),
    }
  },
  watch: {
    'form.status': {
      deep: true,
      immediated: true,
      handler(val) {
        if (val == '1') {
          this.column = [
            { label: '操作', slotName: 'change' },
            { label: '收费医馆', prop: 'deptName', showOverflowTooltip: true },
            { label: '货号', prop: 'productNo', showOverflowTooltip: true },
            { label: '商品名称', prop: 'productName', showOverflowTooltip: true,width: 120 },
            { label: '商品数量', prop: 'qty' },
            { label: '退货数量', prop: 'refundQty' },
            { label: '带货时间', prop: 'updateTime', width: 160 },
            { label: '带货人', prop: 'carrier', width: 80 },
            { label: '带货至', prop: 'carryDeptName', },
            { label: '收货时间', prop: 'affirmTime', width: 160 },
            { label: '收货人', prop: 'affirmName', width: 80 },
            { label: '状态', width: 120,formatter: (row) => { return isNull(row.affirmName) ? '待确认' : '已收货' }},
            { label: '厂家', prop: 'factory', showOverflowTooltip: true },
            { label: '单位', prop: 'unit' },
            { label: '收费时间', prop: 'payTime', width: 160, },
            { label: '收费单号', prop: 'orderNumber', width: 200 },
          ]
        } else {
          this.column = [
            { label: '收费医馆', prop: 'deptName', showOverflowTooltip: true },
            { label: '货号', prop: 'productNo', showOverflowTooltip: true },
            { label: '商品名称', prop: 'productName', showOverflowTooltip: true },
            { label: '商品数量', prop: 'qty' },
            { label: '厂家', prop: 'factory', showOverflowTooltip: true },
            { label: '单位', prop: 'unit' },
            { label: '带货至', prop: 'carryDeptName' },
            { label: '收费时间', prop: 'payTime', width: 160 },
            { label: '收费单号', prop: 'orderNumber', width: 200 },
            { label: '操作', slotName: 'action' }
          ]
        }
      }
    }
  },
  created() {
    this.form.status = '2'
    this.form.date = []
    let isoWeek = this.$moment().startOf('isoWeek').format('yyyy-MM-DD')
    let isoWeekEnd = this.$moment().endOf('isoWeek').format('yyyy-MM-DD')
    this.form.date = [isoWeek, isoWeekEnd]
    this.getList()
  },
  methods: {
    close() {
      this.$emit('close')
    },
    changeStatus(item) {
      this.form.status = item.value
      this.form.pageNum = 1
      this.form.date = []
      let isoWeek = this.$moment().startOf('isoWeek').format('yyyy-MM-DD')
      let isoWeekEnd = this.$moment().endOf('isoWeek').format('yyyy-MM-DD')
      this.form.date = [isoWeek, isoWeekEnd]
      this.getList()
    },
    onSubmit() {
      this.form.pageNum = 1
      this.getList()
    },
    onReset() {
      this.form.productNo = ''
      this.form.pageNum = 1
      this.form.pageSize = 10
      this.form.deptId = ''
      let isoWeek = this.$moment().startOf('isoWeek').format('yyyy-MM-DD')
      let isoWeekEnd = this.$moment().endOf('isoWeek').format('yyyy-MM-DD')
      this.form.date = [isoWeek, isoWeekEnd]
      this.getList()
    },
    pageChange(page) {
      this.form.pageNum = page.current
      this.form.pageSize = page.size
      this.getList()
    },
    async getList() {
      this.tableData = []
      let params = {
        ...this.form,
        startDate: this.$moment(this.form.date[0]).startOf('day').format('yyyy-MM-DD HH:mm:ss'),
        endDate: this.$moment(this.form.date[1]).endOf('day').format('yyyy-MM-DD HH:mm:ss'),
      }
      let { code, rows, total } = await getCarryList(params)
      if (code == 200) {
        this.tableData = rows || []
        this.total = total || 0
      }
    },
    async updateCarrStatus(row) {
      let { code } = await updateCarrStatus(row.orderDetailCarryId)
      if (code == 200) {
        this.form.status == '1' ? this.$message.success('收货成功！') : this.$message.success('标记成功！')
        this.getList()
      }
    },
    handleExport: debounce(async function () {
      let params = {
        reportId: 33,
        ...this.form,
        startDate: this.$moment(this.form.date[0]).startOf('day').format('yyyy-MM-DD HH:mm:ss'),
        endDate: this.$moment(this.form.date[1]).endOf('day').format('yyyy-MM-DD HH:mm:ss')
      }
      let { code, data } = await reportExport(params, { name: '带货数据' })
    }, true, 300),
  }
}
</script>

<style lang="less" scoped>
.header-warp {
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 24px;
  border-bottom: 1px solid #EBEAEE;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;

  .header-warp-close {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
  }

  .header-warp-item {
    font-weight: 400;
    font-size: 16px;
    color: #667182;
  }

  .header-warp-item-active {
    position: relative;
    font-weight: 500;
    color: #000000;

    &::before {
      content: '';
      position: absolute;
      bottom: -18px;
      width: 58px;
      height: 3px;
      background: #1890FF;
      border-radius: 4px 4px 4px 4px;
    }
  }
}

.content-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>